<template>
  <v-container>
    <!-- Task Runner Dialog in its own row -->
    <v-row v-if = "settingsStore.getIsDebugMode">
      <v-col>
      <v-btn
        :color="showSearchProduct ? 'success' : 'primary'"
        size="small"
        rounded="0"
        @click="toggleSearch('product')"
      >
        Search Product
      </v-btn>
      <v-btn
        :color="showSearchCategory ? 'success' : 'primary'"
        size="small"
        rounded="0"
        @click="toggleSearch('category')"
      >
        Search Category
      </v-btn>
      <v-btn
        :color="showSearchPage ? 'success' : 'primary'"
        size="small"
        rounded="0"
        @click="toggleSearch('page')"
      >
        Search Page
      </v-btn>
      </v-col>
    </v-row>

    <!-- Conditionally render Searchproduct and SearchCategory -->
    <v-row v-if="showSearchProduct">
      <v-col>
        <Searchproduct />
      </v-col>
    </v-row>
    <v-row v-if="showSearchCategory">
      <v-col>
        <SearchCategory />
      </v-col>
    </v-row>
    <v-row v-if="showSearchPage">
      <v-col>
        <SearchPage />
      </v-col>
    </v-row>
    <TaskRunnerDialog />

    <!-- Active URL Display centered in a row -->
    <v-row v-if="activeUrlStore.activeUrl">
      <v-col class="text-center">
        <h2>{{ activeUrlStore.activeUrl }}</h2>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col class="text-center">
        <v-alert icon="mdi-information-outline" type="info">
          <span v-if="hasHistory"
            >You have {{ urlHistoryStore.urls.length }} sites stored in
            history</span
          >
          <span v-else>Welcome!</span>. Please click on
          <v-icon icon="mdi-card-search"></v-icon> on top right to start.
        </v-alert>
      </v-col>
    </v-row>
    <!-- URL Count in a row -->
    <v-row>
      <v-col>
        <UrlCountChips />
      </v-col>
    </v-row>
    <!-- if We have active URL-->
    <section v-if="activeUrlStore.activeUrl">
      <v-row v-if="activeUrlStore.getProvider !== Provider.OTHER">
        <v-col>
          <TabsComponent/>
        </v-col>
      </v-row>
      <!--If Site is Other then show warning-->
      <v-row v-if="activeUrlStore.getProvider === Provider.OTHER">
        <v-col>
          <v-alert icon="mdi-alert-circle-outline" type="warning">
            <span
              >Sorry we only support ERS, KBS and IO Sites at the moment. We have looked at
              homepage of this site and this does not look like a known provider. If
              this is a mistake please contact development team.</span
            >
          </v-alert>
        </v-col>
      </v-row>
    </section>
  </v-container>
</template>

<script lang="ts" setup>
  import TaskRunnerDialog from '@/components/TaskRunnerDialog.vue';
  import useFetchHomepage from '@/composables/useFetchHomepage';
  import useProviderWatcher from '@/composables/useProviderWatcher';
  import useFetchSitemap from '@/composables/useFetchSitemap';
  import useProcessSitemapUrls from '@/composables/useProcessSitemapUrls';
  import UrlCountChips from '@/components/UrlCountChips.vue';
  import useFetchUrlsSources from '@/composables/useFetchUrlsSources';
  import useProcessCategory from '@/composables/useProcessCategorySource';
  import useProcessProduct from '@/composables/useProcessProductSource';
  import useProcessPage from '@/composables/useProcessPageSource';
  import { useImageFallbackWatcher } from '@/composables/useImageFallbackWatcher';
  import TabsComponent from '@/components/TabsComponent.vue';
  import { useActiveUrlStore } from '@/store/activeUrlStore';
  import { useUrlHistoryStore } from '@/store/urlHistoryStore';
  import { computed, ref } from 'vue';
  import  Provider  from '@/enums/Provider';
  import Searchproduct from '@/components/Searchproduct.vue';
  import SearchCategory from '@/components/SearchCategory.vue';
  import SearchPage from '@/components/SearchPage.vue';
  import { useSettingsStore } from '@/store/settings/settingsStore';

  const activeUrlStore = useActiveUrlStore();
  const urlHistoryStore = useUrlHistoryStore();
  const settingsStore = useSettingsStore();

  // Computed property to check if the history is not empty
  const hasHistory = computed(() => urlHistoryStore.urls.length > 0);

  const showSearchProduct = ref(false);
  const showSearchCategory = ref(false);
  const showSearchPage = ref(false);

  // This function toggles the visibility of the search components based on the selected type.
  const toggleSearch = (type: 'product' | 'category' | 'page') => {
    if (type === 'product') {
      showSearchProduct.value = !showSearchProduct.value;
      showSearchCategory.value = false;
      showSearchPage.value = false;
    } else if (type === 'category') {
      showSearchCategory.value = !showSearchCategory.value;
      showSearchProduct.value = false;
      showSearchPage.value = false;
    } else if (type === 'page') {
      showSearchPage.value = !showSearchPage.value;
      showSearchProduct.value = false;
      showSearchCategory.value = false;
    }
  };


  // Ensure that useFetchHomepage and useProviderWatcher are called
  useFetchHomepage();
  useProviderWatcher();
  useFetchSitemap();
  useProcessSitemapUrls();
  useFetchUrlsSources();
  useProcessCategory();
  useProcessProduct();
  useProcessPage();
  useImageFallbackWatcher();
</script>
